module.exports = "<bar #bar id=\"bar\"></bar>"